import {
  newsearchsubjects,
  upDateTaskDNote,
  newTask,
  getshowlist,
  getMyCompanyOrders,
  searchsubjects,
  upDataOrderScore,
  upDataOrderNote,
  newOrder,
  getMyOrders,
  getClientSeller,
  getCompanyOrders,
  newReceived,
  updataOrder,
  getWriter,
  getOrderPaymentList,
  getOrderRefundsList,
  newRefund,
  rejectOrder, getSystemOrders,
  getPaymentLink,
  getSellerWechat,
  newPreOrder,
  getPreOrdersList,
  endPreOrder,
  updateOrderDetail,
  orderCancel,
  updataTaskProcess,
  updateOrderProcess,
  linkPreorderToOrder,
  refreshOrderProcess,
  getOrderSalesMembers,
  getOrderSalesMemberCandidates,
  addOrderSalesMember,
  removeOrderSalesMember,
  changeOrderPrimarySales
} from '@/api/order'

const state = {}

const mutations = {}

const actions = {
  getordersalesmembers({ commit }, orderId) {
    return getOrderSalesMembers(orderId)
  },
  getordersalesmembercandidates({ commit }, orderId) {
    return getOrderSalesMemberCandidates(orderId)
  },
  addordersalesmember({ commit }, { orderId, data }) {
    return addOrderSalesMember(orderId, data)
  },
  removeordersalesmember({ commit }, { orderId, userId }) {
    return removeOrderSalesMember(orderId, userId)
  },
  changeorderprimarysales({ commit }, { orderId, data }) {
    return changeOrderPrimarySales(orderId, data)
  },
  updateorderprocess({commit}, data) {
    return new Promise((resolve, reject) => {
      updateOrderProcess(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  refreshorderprocess({commit}, data) {
    return new Promise((resolve, reject) => {
      refreshOrderProcess(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateorderdetail({commit}, data) {
    return new Promise((resolve, reject) => {
      updateOrderDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  endpreorder({commit}, data) {
    return new Promise((resolve, reject) => {
      endPreOrder(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getpreorderlist({commit}, params) {
    return new Promise((resolve, reject) => {
      getPreOrdersList(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newpreorder({commit}, data) {
    return new Promise((resolve, reject) => {
      newPreOrder(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsellerwechat({commit}, params) {
    return new Promise((resolve, reject) => {
      getSellerWechat(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getpaymentlink({commit}, data) {
    return new Promise((resolve, reject) => {
      getPaymentLink(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  rejectorder({commit}, params) {
    return new Promise((resolve, reject) => {
      rejectOrder(params).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatataskdnote({commit}, data) {
    return new Promise((resolve, reject) => {
      upDateTaskDNote(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newtask({commit}, data) {
    return new Promise((resolve, reject) => {
      newTask(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updataorderscore({commit}, data) {
    return new Promise((resolve, reject) => {
      upDataOrderScore(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updataordernote({commit}, data) {
    return new Promise((resolve, reject) => {
      upDataOrderNote(data).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  neworder({commit}, orderdata) {
    return new Promise((resolve, reject) => {
      newOrder(orderdata).then(response => {
        if (response.code === 200) {
          resolve(response)
          return
        }
        reject(new Error(response.msg || '创建订单失败'))
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmyorders({commit}, data) {
    return new Promise((resolve, reject) => {
      getMyOrders(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getclientseller() {
    return new Promise((resolve, reject) => {
      getClientSeller().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getorderpayments({commit}, orderid) {
    return new Promise((resolve, reject) => {
      getOrderPaymentList(orderid).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getorderrefunds({commit}, orderid) {
    return new Promise((resolve, reject) => {
      getOrderRefundsList(orderid).then(respone => {
        resolve(respone)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsystemorders({commit}, date, searchstr, page, itemslimit) {
    return new Promise((resolve, reject) => {
      getSystemOrders(date, searchstr, page, itemslimit).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcompanyorders({commit}, date, searchstr, page, itemslimit) {
    return new Promise((resolve, reject) => {
      getCompanyOrders(date, searchstr, page, itemslimit).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getshowlist({commit}, date, searchstr, page, itemslimit) {
    return new Promise((resolve, reject) => {
      getshowlist(date, searchstr, page, itemslimit).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmycompanyorders({commit}, data) {
    return new Promise((resolve, reject) => {
      getMyCompanyOrders(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newreceived({commit}, newreceived) {
    return new Promise((resolve, reject) => {
      newReceived(newreceived).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updataorder({commit}, data) {
    return new Promise((resolve, reject) => {
      updataOrder(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatataskprocess({commit}, data) {
    return new Promise((resolve, reject) => {
      updataTaskProcess(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getwriter({commit}, params) {
    return new Promise((resolve, reject) => {
      getWriter(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newrefund({commit}, data) {
    return new Promise((resolve, reject) => {
      newRefund(data).then(respones => {
        resolve(respones)
      }).catch(error => {
        reject(error)
      })
    })
  },
  searchsubjects({commit}, data) {
    return new Promise((resolve, reject) => {
      searchsubjects(data).then(respones => {
        resolve(respones)
      }).catch(error => {
        reject(error)
      })
    })
  },
  newsearchsubjects({commit}, subject) {
    return new Promise((resolve, reject) => {
      newsearchsubjects(subject).then(respones => {
        resolve(respones)
      }).catch(error => {
        reject(error)
      })
    })
  },
  linkpreordertoorder({commit}, data) {
    return new Promise((resolve, reject) => {
      linkPreorderToOrder(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  ordercancel({commit}, params) {
    return new Promise((resolve, reject) => {
      orderCancel(params).then(respones => {
        resolve(respones)
      }).catch(error => {
        reject(error)
      })
    })

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

